import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AjaxService {
    constructor(
        private http: HttpClient,
    ) { }

    get(path: string, body: object = {}): Observable<any> {
        return this.http.get(`${environment.api_url}${path}`, body)
            .pipe(
                // retry(3), // retry a failed request up to 3 times
            );
    }

    put(path: string, body: object = {}): Observable<any> {
        return this.http.put(
            `${environment.api_url}${path}`,
            JSON.stringify(body)
        ).pipe(
            // retry(3), // retry a failed request up to 3 times
        );
    }

    post(path: string, pbody: any | HttpParams | null = {}, options: object = {}, formData = false): Observable<any> {
        let body = {};
        if (!formData) {
            if (pbody instanceof HttpParams) {
                body = pbody.toString();
            } else {
                body = JSON.stringify(pbody);
            }
            return this.http.post(
                `${environment.api_url}${path}`,
                body,
                options
            ).pipe(
                // retry(3), // retry a failed request up to 3 times
            );
        } else {
            return this.http.post(
                `${environment.api_url}${path}`,
                pbody,
                options
            ).pipe(
                // retry(3), // retry a failed request up to 3 times
            );
        }
    }

    delete(path: any): Observable<any> {
        return this.http.delete(
            `${environment.api_url}${path}`
        ).pipe(
            // retry(3), // retry a failed request up to 3 times
        );
    }
}
